<template>
  <v-dialog v-model="openDialog"
            max-width="400"
            persistent lazy>
    <v-card>
      <v-card-title class="title">Are You Sure?</v-card-title>
      <v-layout column class="px-3">
        <v-flex>
          <p>
            If a load needs to be rescheduled, go back and click "Update Pick Up ETA."
          </p>
        </v-flex>
        <v-flex>
          <v-textarea
            label="Message"
            v-model="message">
          </v-textarea>
        </v-flex>
      </v-layout>

      <v-card-actions>
        <v-spacer />
        <v-btn color="accent"
               :loading="loadingBtn"
               @click="cancelLoad()">
          Cancel Load
        </v-btn>
        <v-btn flat color="accent" @click="openDialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import API from '@/api/index';
import VFloatField from '@/components/VFloatField';

export default {
  name: 'CancelLoadDialog',
  props: {
    value: {
      type: Boolean,
    },
    loadId: {
      type: String,
    },
    bookedLoadId: {
      type: String,
    },
    listingHumanId: {
      type: String,
    },
  },
  data() {
    return {
      message: null,
      openDialog: this.value,
      loadingBtn: false,
    };
  },
  components: {
    VFloatField,
  },
  watch: {
    value() {
      this.openDialog = this.value;
      if (!this.value) {
        this.resetForm();
      }
    },
    openDialog() {
      this.$emit('input', this.openDialog);
    },
  },
  methods: {
    resetForm() {
      this.message = null;
    },
    async cancelLoad() {
      try {
        this.loadingBtn = true;
        await API.planner.unscheduleBookedLoad({
          loadId: this.listingHumanId,
          bookedLoadId: this.loadId,
        });

        if (this.message) {
          await API.load.updateFulfillment({
            loadId: this.bookedLoadId,
            messageRequest: {
              message: this.message,
              sent: new Date().toISOString(),
            },
          });
        }

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Canceled successfully!',
        });

        this.$emit('refresh', this.loadId);
      } catch ({ message }) {
        this.$store.dispatch('applications/setErrorNotification', {
          message,
        });
      } finally {
        this.loadingBtn = false;
        this.openDialog = false;
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/CancelLoadDialog.vue